function isPlainObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

function finiteNonNegativeNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) ? Math.max(0, number) : null;
}

export function normalizeLootConditionContext(value) {
  const out = {};
  if (!isPlainObject(value)) {
    return out;
  }
  const fishingMastery = finiteNonNegativeNumber(value.fishingMastery ?? value.mastery);
  const fishingLifeskillLevel = finiteNonNegativeNumber(
    value.fishingLifeskillLevel ?? value.lifeskill_level,
  );
  if (fishingMastery != null) {
    out.fishingMastery = fishingMastery;
  }
  if (fishingLifeskillLevel != null) {
    out.fishingLifeskillLevel = fishingLifeskillLevel;
  }
  return out;
}
